module.exports = {
    navBar: {
        'introduction': '公司簡介',
        'servicedoffice': '服務式辦公室',
        'virtualoffice': '虛擬辦公室',
        'professionalservices': '專業服務',
        'contactus': '聯絡我們'
    },
    footer: {
        'copyright': ['版權歸保仕國際商務中心所有.', '不得轉載.'],
        'home': '首頁',
        'introduction': '公司簡介',
        'servicedoffice': '服務式辦公室',
        'virtualoffice': '虛擬辦公室',
        'professionalservices': '專業服務',
        'contactus': '聯絡我們',
        'address': '香港九龍尖沙咀東部麼地道66號尖沙咀中心東翼811室'
    },
    contactUs: {
        'title': '聯繫我們',
        'address': {
            'title': '公司地址',
            'address': '香港九龍尖沙咀東部麼地道66號尖沙咀中心東翼811室'
        },
        'phone': {
            'title': '電話',
            'phone': '+852 2268 6888'
        },
        'fax': {
            'title': '傳真',
            'fax': '+852 2721 3881'
        },
        'email': {
            'title': '電郵',
            'email': 'enquiry@ibchk.com'
        },
        'p1': '辦公時間',
        'p2': ['週一至週五 - 09.00 to 18.00', '週六 - 09.00 to 13.00'],
        'p3': '(香港時間按東八區為準)'
    },
    videoContainer: {
        'readMore': '了解更多'
    },
    introduction: {
        'h2': '保仕國際商務中心',
        'text': '保仕國際商務中心為您提供位於香港最負盛名的商業區——尖沙咀中心的辦公一站式服務。我們提供設施齊全的辦公室供您租用，同時亦有理想的虛擬辦公室地址供您使用。我們亦提供各種專業的服務，包括：成立公司、財會服務、辦公管理及全方位的秘書服務。我們有保仕集團旗下的其它十三個子公司作為後盾，必定能滿足您公司各方面的商業需求。無論是公司的日常運營還是市場營銷或是企業融資，我們都將竭誠為您服務。我們訓練有素的員工在協助您高效辦公的同時，亦給您帶來家一般溫馨的辦公氛圍。選擇保仕商務中心，就是選擇了滿意、放心及舒心。',
        'readMore': '了解更多'
    },
    introductionPage: {
        'h1': '公司簡介',
        'text': '保仕國際商務中心的服務始於1986年，是香港首家為本土及海外客戶提供全方位專業服務的商務中心。',
    },
    servicedOfficesPage: {
        'h1': '服務式辦公室',
        'p1': '我們擁有二十七間類型迥異，裝潢雅緻的辦公室可供您選擇。辦公室的面積從50平米到250平米不等，您可根據您的需求選擇長租或短租。我們同時還配備訓練有素的員工為您提供最專業的服務。',
        'p2': '我們的月租費用包括房租、電費、空調費、前台接待、信件查收、電話、傳真、寬帶上網、物業管理費、政府稅金、每日清潔費及茶水供應。',
        'p3': '長租或者租用多間辦公室的客戶，可享受折扣優惠。'
    },
    virtualOfficePage: {
        'h1': '虛擬辦公室',
        'text': '如果您需要的只是辦公地址、電話及/或傳真，我們的虛擬辦公室服務，即企業身份項目（BIP）是您最佳的選擇。該項目是為只需顯示企業存在或身份、使用辦公設施及調用員工的企業量身定制的。我們可隨時隨地根據您的需求將您升級至最適合您我們的虛擬辦公室項目。',
        'basic': {
            'title': '基本服務',
            'text': [
                ['以下任選', '一', '項:'],
                ['商業地址服務:', '使用我們的地址用於查收信件'],
                ['電話服務:', '使用我們的電話號碼用於留言'],
                ['傳真服務:', '使用我們的傳真號碼用於發送及接受傳真']
            ]
        },
        'basicplus': {
            'title': '升級服務',
            'text': [
                ['以下任選', '兩', '項:'],
                ['商業地址服務:', '使用我們的地址用於查收信件'],
                ['電話服務:', '使用我們的電話號碼用於留言'],
                ['傳真服務:', '使用我們的傳真號碼用於發送及接受傳真']
            ]
        },
        'premium': {
            'title': '豪華服務',
            'text': [
                ['享用', '所有', '下列項目:'],
                ['商業地址服務:', '使用我們的地址用於查收信件'],
                ['電話服務:', '使用我們的電話號碼用於留言'],
                ['傳真服務:', '使用我們的傳真號碼用於發送及接受傳真'],
            ]
        },
        'premiumplus': {
            'title': '頂級服務',
            'text': [
                ['私人電話接線:', '來電以貴公司的名稱來接聽'],
                ['商業地址的使用:', '使用我們的地址用於查收信件'],
                ['私人傳真的使用:', '使用私人的傳真號碼用於發送及接受傳真']
            ]
        },
        'registeredaddress': {
            'title': '註冊地址',
            'text': [
                '使用我們的商務中心作為註冊地址，只限使用接收政府公文及公告',
            ]
        }
    },
    professionalServicesPage: {
        'h1': '專業服務',
        'table': [
            { 'title': '成立公司', 'des': ['香港有限公司', '香港個人獨資公司', '香港合夥企業', '英國維京群島及其它離岸公司'] },
            { 'title': '相關的公司服務', 'des': ['公司秘書', '年報稅表（香港法定要求）', '公司名稱變更', '公司銀行賬戶開設', '公司註銷'] },
            { 'title': '秘書服務', 'des': '委派一名秘書為貴公司協助處理所有日常工作' },
            { 'title': '簽證申請', 'des': '代辦香港身份證、工作簽證、投資簽證、回鄉證及駕照等。' },
            {
                'title': '貿易支持', 'text': '準備、協調所有的運輸單據及管理文件，包括：',
                'des': ['聯繫您的客戶、供應商、承運人及銀行', '準備訂單、發票、包裝列表、運輸許可證、清關',
                    '信用證開戶、信用證文件證明', '準備生產計劃、安排裝運、檢驗產品及所有其它程序'
                ]
            },
            { 'title': '大中華市場', 'des': '提供的服務從貨物及服務的外包、市場策劃、銷售到市場調研；從物色合夥人、合資企業及收購到解決任何疑難' },
            { 'title': '市場營銷', 'des': '協助一系列的市場營銷活到，從電話營銷、直接郵寄、定期投郵、傳真或電郵到大規模的市場策劃及推廣活動。' },
            { 'title': '宣傳推廣', 'des': '組織及協調客戶所需的所有研討會及展覽，其服務包括場地預訂、廣告策劃、宣傳冊設計及打印、邀請函發​​出、登記及僱傭研討會或展覽所需的工作人員。同時亦根據客戶的特定需求組織大型的、高規格的品牌宣傳活動。' },
            { 'title': '招聘員工', 'des': '滿足客戶的招聘需求、獵頭服務、廣告、篩選及面試安排' },
            { 'title': '會計服務', 'des': '管理及協調客戶會計及記賬要求，可協助準備賬單、欠款單、發票及處理所有的抵用券、清單、賬簿、財務報告、賬目控制及建立賬務系統' },
            { 'title': '稅務諮詢及規劃', 'des': '有保仕集團精英註冊會計師隊伍的支持，能提供全方位的稅務諮詢及規劃服務' },
            {
                'title': '其他秘書及位置服務',
                'des': ['數據輸入',
                    '中英文打字或文字處理',
                    '研究及諮詢收集',
                    '執照申請（紡織許可證等）',
                    '再開票',
                    '酒店、機票及其它預訂服務',
                    '郵件及網絡服務',
                    '掃描、訂裝及包裝',
                    '打印及復印',
                    '運輸安排',
                    '海內外快件安排',
                    '數碼照相'
                ]
            }
        ],
        'remarks': '以上未提及的其他服務，亦歡迎您的諮詢。我們盡快給您答復，替您解憂。'
    },
    'amenities': {
        'h2': '我們的服務',
        'text': ['設備完善的辦公空間',
            '會議室',
            '靈活及客制化條款',
            '7天 x 24小時自由進出',
            '前台行政協助',
            '信件及包裹收派服務',
            '荼水及咖啡',
            '專業的商業服務及方案'
        ]
    }
}